// /* Copyright 2013 VMware, Inc. All rights reserved. -- VMware Confidential */
// /*
//  * This js file has to be loaded first.
//  */
h5 = h5 || {};
h5.admin = {
   angularModule: angular.module('com.vmware.vsphere.client.admin', ['com.vmware.platform.ui'])
};

// angular.module('com.vmware.vsphere.client.admin');